<template>
  <div>
    <div style="display: flex; align-items: center; justify-content: center">
      <div style="margin-bottom: 40px !important" class="col form-group">
        <div class="section-row div-flex-row">
          <!-- Zip Code -->
          <input
            ref="cepInput"
            id="cep"
            v-model="obj.cep"
            :v-mask="masks"
            :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
            :placeholder="translation.cep"
            type="text"
            @keyup="getCEP"
          />

          <!-- City -->
          <input
            ref="cepInput"
            v-model="obj.localidade"
            :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
            :placeholder="translation.cidade"
            :disabled="disableLocalidade"
            type="text"
          />
        </div>

        <div class="section-row">
          <!-- Address -->
          <input
            type="text"
            name=""
            v-model="obj.logradouro"
            :disabled="disableLogradouro"
            ref="cepInput"
            class="mt-4 w-100"
            :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
            :placeholder="translation.endereço"
          />

          <!-- Neighborhood -->
          <div class="section-row div-flex-row">
            <input
              v-if="!obj.passport"
              type="text"
              name=""
              v-model="obj.bairro"
              :disabled="disableBairro"
              ref="cepInput"
              class="mt-4"
              :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
              :placeholder="$t('cep.neighborhood')"
            />

            <!-- State (Foreign) -->
            <div v-if="obj.passport" class="mt-4 d-flex flex-column w-100">
              <input
                type="text"
                name=""
                v-model="obj.uf"
                :disabled="disableBairro"
                ref="cepInput"
                :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
                :placeholder="translation.estado"
                maxlength="4"
              />
              <small class="text-muted mt-2">{{ translation.estadoHint }}</small>
            </div>

            <!-- State (Brazil) -->
            <select
              v-if="!obj.passport"
              v-model="obj.uf"
              :disabled="disableUf"
              ref="ufInput"
              class="uf mt-4"
              :class="template.secondaryTheme ? 'secondary-input-theme' : 'c-input'"
            >
              <option
                :style="
                  template.secondaryTheme ? 'color:black !important' : 'color:black !important'
                "
                value=""
                disabled
                hidden
              >
                Escolha o Estado
              </option>

              <option
                :style="
                  template.secondaryTheme ? 'color:black !important' : 'color:black !important'
                "
                v-for="estado in estados"
                :key="estado.sigla"
                :value="estado.sigla"
              >
                {{ estado.sigla }}
              </option>
            </select>
          </div>

          <div class="section-row div-flex-row">
            <!-- Number -->
            <input
              type="text"
              name=""
              v-model="obj.numero"
              ref="cepInput"
              class="numero mt-4"
              :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
              :placeholder="$t('cep.number')"
            />

            <!-- Complement -->
            <input
              type="text"
              name=""
              v-model="obj.complement"
              ref="cepInput"
              class="complemento mt-4"
              :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
              :placeholder="translation.complemento"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* State */
import { mapState, mapMutations } from 'vuex'

/* Helpers */
import { mask } from 'vue-the-mask'

/* Services */
import axios from 'axios'

export default {
  name: 'Cep',
  mask: {
    ...mask,
    tokens: {
      ...mask.tokens,
      null: /./,
    },
  },
  props: {
    validate: Boolean,
  },
  data: () => ({
    obj: {
      uf: null,
    },
    estados: [],
    disableLocalidade: false,
    disableLogradouro: false,
    disableBairro: false,
    disableUf: false,
    toastMessage: '',
  }),
  computed: {
    ...mapState(['config', 'template', 'registrationObject', 'subdomain']),
    masks() {
      if (this.obj.passport) {
        return []
      }
      return ['#####-###', '#####-###']
    },
    translation() {
      return {
        attention: this.$t('common.attention'),
        cep: this.$t('cep.cep'),
        cidade: this.$t('cep.city'),
        endereço: this.$t('cep.address'),
        complemento: this.$t('cep.complement'),
        estado: this.$t('cep.state'),
        estadoHint: this.$t('cep.stateHint'),
        msgError: {
          cep: this.$t('cep.cepRequired'),
          number: this.$t('cep.numberRequired'),
          onlyNumber: this.$t('cep.onlyNumber'),
          address: this.$t('cep.addressRequired'),
          state: this.$t('cep.stateRequired'),
        },
      }
    },
  },
  watch: {
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },
  mounted() {
    // Create a deep copy of the object in the store
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))
    document.getElementById('cep').focus()
    if (!this.obj.passport) {
      this.getState()
    }
  },
  methods: {
    ...mapMutations([
      'updateRegistrationObject',
      'clearRegistrationErrors',
      'addRegistrationError',
    ]),
    getState() {
      const url = `${process.env.VUE_APP_FANPAGEDOMAIN}/api/identity/ufs/`
      axios.get(url).then(response => {
        this.estados = response.data.data
        if (this.estados.length > 0 && !this.obj.uf) {
          this.obj.uf = this.estados[0].sigla
        }
      })
    },
    handleDisableInputs() {
      if (this.obj.localidade) {
        this.disableLocalidade = true
      }
      if (this.obj.logradouro) {
        this.disableLogradouro = true
      }
      if (this.obj.bairro) {
        this.disableBairro = true
      }
      if (this.obj.uf) {
        this.disableUf = true
      }
    },
    getCEP() {
      if (!this.obj.passport) {
        let ceptext = this.obj.cep.replace('-', '')

        if (ceptext.length == 8) {
          const urlViaCep = `https://viacep.com.br/ws/${ceptext}/json/`
          const urlFanpageApi = `${process.env.VUE_APP_FANPAGEDOMAIN}/api/identity/zipCode/${ceptext}`

          axios.get(urlViaCep).then(
            response => {
              let dados = response.data
              this.obj = dados
              this.handleDisableInputs()
            },
            error => {
              if (this.obj.livesInBrazil === false) {
                return alert(error)
              } else {
                axios.get(urlFanpageApi).then(
                  response => {
                    let dados = response.data.data
                    this.obj = dados
                    this.handleDisableInputs()
                  },
                  err => {
                    return alert(err)
                  },
                )
              }
            },
          )
        }
      }
    },
    makeToast(variant = null) {
      this.$bvToast.toast(this.toastMessage, {
        title: this.translation.attention,
        variant: variant,
        solid: true,
      })
    },
    validateFields() {
      this.$emit('validating')

      this.clearRegistrationErrors()

      let hasErrors = false

      if (!this.obj.cep) {
        this.addRegistrationError({
          msg: this.translation.msgError.cep,
        })
        this.toastMessage = this.translation.msgError.cep
        this.makeToast('warning')

        hasErrors = true
      }

      if (!this.obj.numero) {
        this.addRegistrationError({
          msg: this.translation.msgError.number,
        })
        this.toastMessage = this.translation.msgError.number
        this.makeToast('warning')

        hasErrors = true
      } else if (!/^\d+$/.test(this.obj.numero)) {
        this.addRegistrationError({
          msg: this.translation.msgError.onlyNumber,
        })
        this.toastMessage = this.translation.msgError.onlyNumber
        this.makeToast('warning')

        hasErrors = true
      }

      if (!this.obj.bairro && !this.obj.passport) {
        const warningMsg = this.$t('cep.neighborhoodRequired')
        this.addRegistrationError({
          msg: warningMsg,
        })
        this.toastMessage = warningMsg
        this.makeToast('warning')

        hasErrors = true
      }

      if (!this.obj.localidade || !this.obj.logradouro) {
        this.addRegistrationError({
          msg: this.translation.msgError.address,
        })
        this.toastMessage = this.translation.msgError.address
        this.makeToast('warning')

        hasErrors = true
      }

      if (!this.obj.uf) {
        this.addRegistrationError({
          msg: this.translation.msgError.state,
        })
        this.toastMessage = this.translation.msgError.state
        this.makeToast('warning')

        hasErrors = true
      }

      if (!hasErrors) {
        this.$store.commit('updateRegistrationObject', this.obj)
        this.$emit('next')
      }
    },
  },
}
</script>

<style scoped>
.complemento {
  width: 75%;
}

.numero {
  width: 25%;
}

.bairro {
  width: 75%;
}

.uf {
  color: white !important;
  width: 25%;
  position: relative;
  padding: 8px 0;
  z-index: 1; /* Garante que o select esteja acima dos outros elementos */
}

/* Evitar que a lista expanda para cima */
.section-row {
  position: relative; /* Define o contexto de empilhamento */
  z-index: 0; /* Certifique-se de que não obstrua o select */
}

.estado option {
  color: black;
  background-color: white;
  line-height: inherit;
}

.div-flex-row {
  display: flex;
  gap: 16px;
}

.section-row {
  width: 330px;
}
</style>
